<template>
    <div style="max-width: 770px;">
        <Steps steps="3" current="3" links="false" />
        <form @submit.prevent="validateBeforeSubmit" class="pb-5">
            <div class="txt-grey">Welcome back, {{auth.userDetails.firstName}}</div>
            <h3 class="uc">THANKS FOR CONFIRMING YOUR IDENTITY</h3>
            <p class="light mb-4">Check the information below is correct then submit your loan request.</p>

            <fieldset class="mb-4">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <LoanSelect
                            label="How much do you want to borrow?"
                            id="loan_amount"
                            name="loan_amount"
                            type="tel"
                            v-model="loan_amount"
                            v-validate="'required'"
                            errormsg="This is a required field"
                            :error="errors.first('loan_amount')" />
                    </div>
                </div>

                <div class="row" v-if="this.loan_amount_raw > 1000">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="Estimated Credit Score"
                            id="creditScore"
                            name="creditScore"
                            v-model="creditScore"
                            v-validate="'required'"
                            :options="[{value: 'excellent', label: '720+'}, {value: 'good', label: '660-719'}, {value: 'fair', label: '600-659'}, {value: 'poor', label: '599 or less'}]"
                            errormsg="This is a required field"
                            :error="errors.first('creditScore')" 
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="What’s the purpose of your loan?"
                            id="loanPurpose"
                            name="loanPurpose"
                            v-model="loanPurpose"
                            v-validate="'required'"
                            :options="[{value: 'debt consolidation', label: 'Debt Consolidation'}, {value: 'medical', label: 'Medical'}, {value: 'home improvement', label: 'Home Improvement'}, {value: 'credit card consolidation', label: 'Credit Card Consolidation'}, {value: 'auto purchase', label: 'Auto Purchase'}, {value: 'major', label: 'Major Purpose'}, {value: 'business', label: 'Start a Business or Business'}, {value: 'vacation', label: 'Vacation'}, {value: 'wedding', label: 'Wedding'}, {value: 'other', label: 'Other'}]"
                            errormsg="This is a required field"
                            :error="errors.first('loanPurpose')" 
                        />
                    </div>
                </div>

                <div class="row" v-if="this.loanPurpose == 'debt consolidation'">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="How much debt do you have?"
                            id="debtAmount"
                            name="debtAmount"
                            v-model="debtAmount"
                            v-validate="'required'"
                            :options="[{value: '7500', label: 'Under $7500'}, {value: '10000', label: '$7500 - $10,000'}, {value: '15000', label: '$10,000 - $15,000'}, {value: '20000', label: '$15,000 - $20,000'}, {value: '25000', label: '$20,000 - $25,000'}, {value: '30000', label: '$25,000 - $30,000'}, {value: '35000', label: '$30,000 - $35,000'}, {value: '40000', label: '$35,000 - $40,000'}, {value: '45000', label: '$40,000 - $45,000'}, {value: '50000', label: '$45,000+'}]"
                            errormsg="This is a required field"
                            :error="errors.first('debtAmount')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <Select
                            label="When is your next pay day?"
                            id="nextPaydate"
                            name="nextPaydate"
                            v-model="nextPaydate"
                            v-validate="'required'"
                            :options="paymentDates"
                            errormsg="This is a required field"
                            :error="errors.first('nextPaydate')" 
                        />
                    </div>
                </div>
            </fieldset>

            <div class="card mb-4" v-if="!editing">
                <div class="card-header">Your Details</div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <div class="p12">Email</div>
                                <div class="p16">{{auth.userDetails.email}}</div>
                            </div>

                            <div class="mb-4">
                                <div class="p12">Phone</div>
                                <div class="p16">{{formattedHomePhone}}</div>
                            </div>

                            <div class="">
                                <div class="p12">Address</div>
                                <div class="p16">{{auth.userDetails.city}}, {{auth.userDetails.state}} {{auth.userDetails.zip}}</div>
                            </div>
                        </div><!--End Col-->
                        <div class="col-lg-6">
                            <div class="mb-4">
                                <div class="p12">Routing Number / Bank Account</div>
                                <div class="p16">{{auth.userDetails.bankRoutingNumber}} / {{auth.userDetails.bankAccountNumber}}</div>
                            </div>

                            <div class="mb-4">
                                <div class="p12">Employer</div>
                                <div class="p16">{{auth.userDetails.employerName}}</div>
                            </div>

                            <div class="">
                                <div class="p12">Monthly Income</div>
                                <div class="p16">${{auth.userDetails.monthlyIncome}}</div>
                            </div>
                        </div><!--End Col-->
                    </div><!--End Row-->
                </div><!--End Card Body-->
                <div class="card-footer light p14">
                    <strong>Something not accurate?</strong>  &nbsp;<a href="#" @click.prevent="editDetails">Click here to update your details</a>
                </div>
            </div><!--End Card-->

            

            <div v-if="editing" class="pt-4">
                <h4 class="uc">Personal Information</h4>
                <fieldset class="mb-5">
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your first name?"
                                id="firstName"
                                name="firstName"
                                v-model="firstName"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('firstName')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your last name?"
                                id="lastName"
                                name="lastName"
                                v-model="lastName"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('lastName')" 
                            />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <CleaveInput
                                label="What's your phone number?"
                                id="phone"
                                name="phone"
                                type="tel"
                                maxlength="12"
                                help="Format: 999-999-9999"
                                :cleaveoptions="masks.phone"
                                v-model="phone"
                                v-validate="{ required: true, validateAreaCode: true, regex: /^[0-9]{3}\-[0-9]{3}\-[0-9]{4}$/ }"
                                :exval="validationAttempt"
                                :error="errors.first('phone')"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="app-row">
                                <label for="ssn" class="focused">What's your SSN?</label>
                                <input class="form-control"
                                    id="ssn"
                                    name="ssn"
                                    disabled
                                    :value="this.ssn"
                                    autocomplete="off"
                                >
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-6 col-xl-4">
                            <CleaveInput
                                label="When is your date of birth?"
                                id="dob"
                                name="dob"
                                type="tel"
                                :cleaveoptions="masks.date"
                                help="Format: mm/dd/yyyy"
                                v-model="dob"
                                maxlength="10"
                                v-validate="'required|date_format:MM/dd/yyyy|validateAge'"
                                :exval="validationAttempt"
                                errormsg="You must be at least 18 years old"
                                :error="errors.first('dob')"
                            />
                            
                        </div>
                    </div>
                    
                </fieldset>

                <h4 class="uc">Address Information</h4>
                <fieldset class="mb-5">
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your address?"
                                id="address"
                                name="address"
                                v-model="address"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('address')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-xl-4">
                        <CleaveInput
                                label="What's your zipcode?"
                                id="zipcode"
                                name="zipcode"
                                maxlength="5"
                                type="tel"
                                v-model="zipcode"
                                v-validate="{ required: true, regex: /^[0-9]{5}$/ }"
                                :exval="validationAttempt"
                                :cleaveoptions="masks.zipcode"
                                errormsg="This is a required field"
                                :error="errors.first('zipcode')" 
                            />
                        </div>
                        <div class="col-lg-5 col-xl-4">
                            <Select
                                label="What's your state?"
                                id="address_state"
                                name="address_state"
                                v-model="address_state"
                                v-validate="'required'"
                                :options="['AL','AK','AZ','CA','CO','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NC','ND','OH','OK','OR','PA','RI','SC','TN','TX','UT','VA','WA','WI','WY']"
                                errormsg="This is a required field"
                                :error="errors.first('address_state')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your city?"
                                id="city"
                                name="city"
                                v-model="city"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('city')" 
                            />
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-10 col-xl-8">
                            <Select
                                label="Time spent at this address?"
                                id="monthsAtAddress"
                                name="monthsAtAddress"
                                v-model="monthsAtAddress"
                                v-validate="'required'"
                                :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                                errormsg="This is a required field"
                                :error="errors.first('monthsAtAddress')"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="form-group mb-0">
                                <div class="mb-2 check-label">Do you own or rent?</div>
                                <div class="radio-options">
                                    <div class="radio-option" :class="homeOwnership == 'rent' ? 'selected' : ''" @click="homeOwnership='rent'">
                                        I rent
                                    </div>
                                    <div class="radio-option" :class="homeOwnership == 'own' ? 'selected' : ''" @click="homeOwnership='own'">
                                        I own
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <h4 class="uc">License/ID Information <a class="p12" href="#" @click.prevent="editLicenseDetails">Click here to edit</a></h4>
                <fieldset class="mb-5" v-if="editingLicenseDetails">
                    <div class="row">
                        <div class="col-lg-5 col-xl-4">
                            <BasicInput
                                label="Driver's license/State ID"
                                id="driversLicense"
                                name="driversLicense"
                                autocomplete="off"
                                v-model="driversLicense"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('driversLicense')"
                            />
                        </div>
                        <div class="col-lg-5 col-xl-4">
                            <Select
                                label="State issued"
                                id="driversLicenseState"
                                name="driversLicenseState"
                                v-model="driversLicenseState"
                                v-validate="'required'"
                                :options="['AL','AK','AZ','CA','CO','DE','DC','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NC','ND','OH','OK','OR','PA','RI','SC','TN','TX','UT','VA','WA','WI','WY']"
                                errormsg="This is a required field"
                                :error="errors.first('driversLicenseState')" 
                            />
                        </div>
                    </div>
                </fieldset>

                <fieldset class="mb-5" v-else>
                    <div class="row">
                        <div class="col-lg-5 col-xl-4">
                            <div class="app-row">
                                <label for="driversLicense" class="focused">Driver's license/State ID</label>
                                <input class="form-control"
                                    id="driversLicense"
                                    name="driversLicense"
                                    disabled
                                    :value="this.driversLicense"
                                    autocomplete="off"
                                >
                            </div>
                        </div>
                        <div class="col-lg-5 col-xl-4">
                            <div class="app-row">
                                <label for="driversLicenseState" class="focused">State issued</label>
                                <input class="form-control"
                                    id="driversLicenseState"
                                    name="driversLicenseState"
                                    disabled
                                    :value="this.driversLicenseState"
                                >
                            </div>
                        </div>
                    </div>
                </fieldset>

                <h4 class="uc">Employment Information</h4>
                <fieldset class="mb-3">
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="form-group mb-0">
                                <div class="mt-3 mb-2 check-label">What's your income type?</div>                           
                                <div class="radio-options">
                                    <div class="radio-option align-items-center" :class="employmentType == 'employed' ? 'selected' : ''" @click="employmentType='employed'">
                                        <span>Employed</span>
                                    </div>
                                    <div class="radio-option" :class="employmentType == 'benefits' ? 'selected' : ''" @click="employmentType='benefits'">
                                        Benefits
                                    </div>
                                    <div class="radio-option" :class="employmentType == 'self-employed' ? 'selected' : ''" @click="employmentType='self-employed'">
                                        Self-Employed
                                    </div>
                                    <div class="radio-option" :class="employmentType == 'military' ? 'selected' : ''" @click="employmentType='military'">
                                        Military or Dependent
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="form-group mb-0">
                                <div class="mt-3 mb-2 check-label">How frequently are you paid?</div>                           
                                <div class="radio-options">
                                    <div class="radio-option" :class="payFrequency == 'weekly' ? 'selected' : ''" @click="payFrequency='weekly'">
                                        Weekly
                                    </div>
                                    <div class="radio-option align-items-center" :class="payFrequency == 'biweekly' ? 'selected' : ''" @click="payFrequency='biweekly'">
                                        Bi-Weekly
                                    </div>
                                    <div class="radio-option" :class="payFrequency == 'semi-monthly' ? 'selected' : ''" @click="payFrequency='semi-monthly'">
                                        Twice Monthly
                                    </div>
                                    <div class="radio-option" :class="payFrequency == 'monthly' ? 'selected' : ''" @click="payFrequency='monthly'">
                                        Monthly
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="form-group mb-0">
                                <div class="mt-3 mb-2 check-label">How are you paid?</div>                           
                                <div class="radio-options">
                                    <div class="radio-option" :class="payType == 'direct_deposit' ? 'selected' : ''" @click="payType='direct_deposit'">
                                        Direct Deposit
                                    </div>
                                    <div class="radio-option align-items-center" :class="payType == 'check' ? 'selected' : ''" @click="payType='check'">
                                        Paper Check
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="mb-5">
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your employer's name?"
                                id="employerName"
                                name="employerName"
                                v-model="employerName"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('employerName')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <Select
                                label="How long have you worked there?"
                                id="monthsEmployed"
                                name="monthsEmployed"
                                v-model="monthsEmployed"
                                v-validate="'required'"
                                :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                                errormsg="This is a required field"
                                :error="errors.first('monthsEmployed')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <Select
                                label="What is your monthly income?"
                                id="monthlyIncome"
                                name="monthlyIncome"
                                v-model="monthlyIncome"
                                v-validate="'required'"
                                :options="[{value: '6000', label: 'More than $5,000'}, {value: '5000', label: '$4500 - $5000'}, {value: '4500', label: '$4001 - $4500'}, {value: '4000', label: '$3501 - $4000'}, {value: '3500', label: '$3001 - $3500'}, {value: '3000', label: '$2501 - $3000'}, {value: '2500', label: '$2001 - $2500'}, {value: '1000', label: '$1000 or less'}, {value: '2000', label: '$1501 - $2000'}, {value: '1500', label: '$1001 - $1500'}]"
                                errormsg="This is a required field"
                                :error="errors.first('monthlyIncome')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-7 col-xl-6">
                            <CleaveInput
                                label="Work phone number"
                                id="workPhone"
                                name="workPhone"
                                type="tel"
                                maxlength="12"
                                help="Lenders require this to verify employment, you must provide an accurate number to obtain a loan.<br><br>Format: 999-999-9999."
                                :cleaveoptions="masks.workPhone"
                                v-model="workPhone"
                                v-validate="{ required: true, validateAreaCode: true, regex: /^[0-9]{3}\-[0-9]{3}\-[0-9]{4}$/ }"
                                :exval="validationAttempt"
                                :error="errors.first('workPhone')"
                            />
                        </div>
                        <div class="col-lg-3 col-xl-2">
                            <BasicInput
                                label="Extension"
                                id="workExt"
                                name="workExt"
                                type="tel"
                                v-model="workExt"
                                :exval="validationAttempt"
                                :error="errors.first('workExt')"
                            />
                        </div>
                    </div>
                </fieldset>

                <h4 class="uc">Bank Information <a class="p12" href="#" @click.prevent="editBankDetails">Click here to edit</a></h4>
                <fieldset class="mb-5" v-if="editingBankDetails">
                    <div class="mb-3">
                        <div class="row">
                            <div class="col-lg-10 col-xl-8">
                                <div class="form-group mb-0">
                                    <div class="mt-3 mb-2 check-label">What's your account type?</div>                           
                                    <div class="radio-options">
                                        <div class="radio-option" :class="bankAccountType == 'checking' ? 'selected' : ''" @click="bankAccountType='checking'">
                                            Checking Account
                                        </div>
                                        <div class="radio-option align-items-center" :class="bankAccountType == 'saving' ? 'selected' : ''" @click="bankAccountType='saving'">
                                            Savings Account
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-xl-4">
                            <CleaveInput
                                label="ABA / Bank routing number"
                                id="bankRoutingNumber"
                                name="bankRoutingNumber"
                                maxlength="9"
                                type="tel"
                                :cleaveoptions="masks.aba"
                                v-model="bankRoutingNumber"
                                v-validate="'required|validateABA'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('bankRoutingNumber')" 
                            />
                        </div>
                        <div class="col-lg-5 col-xl-4">
                            <BasicInput
                                label="Bank account number"
                                id="bankAccountNumber"
                                name="bankAccountNumber"
                                type="tel"
                                autocomplete="off"
                                v-model="bankAccountNumber"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('bankAccountNumber')" 
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <BasicInput
                                label="What's your bank's name?"
                                id="bankName"
                                name="bankName"
                                v-model="bankName"
                                v-validate="'required'"
                                :exval="validationAttempt"
                                errormsg="This is a required field"
                                :error="errors.first('bankName')" 
                            />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <Select
                                label="How long have you had the account?"
                                id="monthsAtBank"
                                name="monthsAtBank"
                                v-model="monthsAtBank"
                                v-validate="'required'"
                                :options="[{value: '84', label: '7 years or more'}, {value: '72', label: '6 years'}, {value: '60', label: '5 years'}, {value: '48', label: '4 years'}, {value: '36', label: '3 years'}, {value: '24', label: '2 years'}, {value: '12', label: 'One year or less'}]"
                                errormsg="This is a required field"
                                :error="errors.first('monthsAtBank')" 
                            />
                        </div>
                    </div>

                </fieldset>
                <fieldset class="mb-5" v-else>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="app-row">
                                <label for="bankAccountType" class="focused">What's your account type?</label>
                                <input class="form-control"
                                    id="bankAccountType"
                                    name="bankAccountType"
                                    disabled
                                    :value="this.bankAccountType"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-5 col-xl-4">
                            <div class="app-row">
                                <label for="bankRoutingNumber" class="focused">ABA / Bank routing number</label>
                                <input class="form-control"
                                    id="bankRoutingNumber"
                                    name="bankRoutingNumber"
                                    disabled
                                    :value="this.bankRoutingNumber"
                                >
                            </div>
                        </div>
                        <div class="col-lg-5 col-xl-4">
                            <div class="app-row">
                                <label for="bankAccountNumber" class="focused">Bank account number</label>
                                <input class="form-control"
                                    id="bankAccountNumber"
                                    name="bankAccountNumber"
                                    autocomplete="off"
                                    disabled
                                    :value="this.bankAccountNumber"
                                >
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-10 col-xl-8">
                            <div class="app-row">
                                <label for="bankName" class="focused">What's your bank's name?</label>
                                <input class="form-control"
                                    id="bankName"
                                    name="bankName"
                                    disabled
                                    :value="this.bankName"
                                >
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>

            <div class="light txt-grey p14">Clicking “Submit Loan Request” is my e-signature whereby I consent to the <a href="/legal/privacy" target="_blank">Privacy Policy</a>, <a href="/legal/tos" target="_blank">Terms of Use</a>, <a href="/legal/e-consent" target="_blank">E-Consent</a> and <a href="/legal/disclaimer" target="_blank">Disclaimer</a> and to allow you and <a href="/legal/partners" target="_blank">these companies</a> to use automated methods to send marketing calls or texts to <strong>{{phone}}</strong>, my number that I provided, even if it's on a do not call list. I agree my consent is not a condition to get a loan or other services offered by lenders and related (like pre-paid card, debt relief) providers in your network. I can <a href="/unsubscribe/phone" target="_blank">opt-out of your telemarketing</a> at any time.</div>


            <div class="my-5 d-flex align-items-center flex-wrap">
                <button class="btn btn-cta btn-red uc" :disabled="saving" id="form-submit-short">{{saving ? 'Sending Your Request...' : 'Submit Loan Request'}}</button>
                <div v-if="saving" class="mt-3 mt-md-0 ml-auto ml-md-3 mr-auto mr-md-0">
                    <div class="dots">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
                <div v-if="errorMessage" class="alert alert-danger w-100 mt-4">
                    There was an error submitting your application. Please try again later.
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import Steps from '@/components/form/Steps.vue';
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import LoanSelect from '@/components/form/LoanSelect.vue';
import Select from '@/components/form/Select.vue';

import axios from 'axios';
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';

import Cleave from 'cleave.js';
require('../../../node_modules/cleave.js/dist/addons/cleave-phone.us.js');


export default {
    name: 'Returning',
    title: 'Welcome Back',
    components:{
        Steps,
        BasicInput,
        CleaveInput,
        LoanSelect,
        Select,
    },
    data() {
	  return {
            validationAttempt: false,
            loading: false,
            editing: false,
            editingBankDetails: false,
            editingLicenseDetails: false,
            errorMessage: false,
            saving: false,

            clientKey: '',

            email: '',
			zipcode: '',
            loan_amount: '',
            loan_amount_raw: 0,
            nextPaydate: '',

            firstName: '',
            lastName: '',
            phone: '',
            dob: '',
            creditScore: '',
            loanPurpose: '',
            debtAmount: '',

            address: '',
            zipcode: '',
            city: '',
            address_state: '',
            monthsAtAddress: '',
            homeOwnership: 'rent',
            driversLicense: '',
            driversLicenseState: '',

            employmentType: 'employed',
            employerName: '',
            monthsEmployed: '',
            monthlyIncome: '',
            payFrequency: 'biweekly',
            nextPaydate: '',
            secondPayDate: '',
            workPhone: '',
            workExt: '',
            payType: 'direct_deposit',

            bankAccountType: 'checking',
            bankRoutingNumber: '',
            bankAccountNumber: '',
            bankName: '',
            monthsAtBank: '',
            ssn: '',

            sid: '',
            bid: '',
            did: '',

            masks: {
                zipcode: { numericOnly: true, blocks: [5] },
                date: { date: true, delimiter: '/', datePattern: ['m', 'd', 'Y'] },
                phone: { numericOnly: true, delimiter: '-', blocks: [3, 3, 4] },
                workPhone: { phone: true, phoneRegionCode: 'US', delimiter: '-'},
                ssn: { numericOnly: true, delimiter: '-', blocks: [3, 2, 4] },
                aba: { numericOnly: true, blocks: [9] },
            }
		}
    },
    methods: {
        ...mapActions(['saveFormData', 'sendToAPI', 'registerPoint']),
        editDetails() {
            this.editing = true
        },
        editBankDetails() {
            this.bankAccountType = 'checking';
            this.bankRoutingNumber = '';
            this.bankAccountNumber = '';
            this.bankName = '';
            this.monthsAtBank = '';
            this.editingBankDetails = true;
        },
        editLicenseDetails() {
            this.driversLicense = '';
            this.driversLicenseState = '';
            this.editingLicenseDetails = true;
        },
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({

                        'clientKey': this.clientKey,

                        'email': this.email.toLowerCase(),
                        'zipcode': this.zipcode,
                        'loan_amount' : this.loan_amount,
                        'loan_amount_raw': this.loan_amount_raw,
                        'firstStep': true,
                        
                        'firstName': this.firstName,
                        'lastName': this.lastName,
                        'phone' : this.phone,
                        'dob' : this.dob,
                        'creditScore' : this.creditScore,
                        'loanPurpose' : this.loanPurpose,
                        'debtAmount' : this.debtAmount,
                        'secondStep': true,
                        
                        'address': this.address,
                        'zipcode': this.zipcode,
                        'city' : this.city,
                        'address_state' : this.address_state,
                        'monthsAtAddress' : this.monthsAtAddress,
                        'homeOwnership' : this.homeOwnership,
                        'driversLicense' : this.driversLicense,
                        'driversLicenseState' : this.driversLicenseState,
                        'thirdStep': true,

                        'employmentType': this.employmentType,
                        'employerName': this.employerName,
                        'monthsEmployed' : this.monthsEmployed,
                        'monthlyIncome' : this.monthlyIncome,
                        'payFrequency' : this.payFrequency,
                        'nextPaydate' : this.nextPaydate,
                        'secondPayDate' : this.secondPayDate,
                        'workPhone' : this.workPhone,
                        'workExt' : this.workExt,
                        'payType' : this.payType,
                        'fourthStep': true,
                        
                        'bankAccountType': this.bankAccountType,
                        'bankRoutingNumber': this.bankRoutingNumber,
                        'bankAccountNumber' : this.bankAccountNumber,
                        'bankName' : this.bankName,
                        'monthsAtBank' : this.monthsAtBank,
                        'ssn' : this.ssn,
                        'fifthStep': true,
                        
                        'sid': this.sid,
                        'bid': this.bid,
                        'did': this.did,
                    });

                    //Send to API replaced with push to Processing
                    this.$router.push({ path: '/registration/processing' });

                } else {
                    this.saving = false;
                }

      		});
        },
        formatPhoneNumber(phoneString = ''){
            const formatted = phoneString.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (formatted) {
                return formatted[1] + '-' + formatted[2] + '-' + formatted[3];
            } else {
                return '';
            }
        },
        formatBirthDate(dateString = ''){
            const formatted = dateString.match(/^(\d{4})\-(\d{2})\-(\d{2})$/);
            if(formatted) {
                return formatted[2] + '/' + formatted[3] + '/' + formatted[1];
            } else {
                return '';
            }
        },
        async getZipCodes(zipcode){
            if(zipcode.length != 5){
                return
            }
            try {
                const response = await axios.get(`${process.env.VUE_APP_LOCAL_API}zipcode/${zipcode}`);
                if(response.data.found){
                    this.city = response.data.data.city;
                    this.address_state = response.data.data.state;
                } else {
                }
            } catch(err){
            }
        },
        isWeekend(date){
            if(date.isoWeekday() == 6 || date.isoWeekday() == 7){
                return true;
            } else {
                return false;
            }
        },
        calculateSecondPaymentDate(){
            if(this.nextPaydate == '' || this.payFrequency == ''){
                return false;
            }
            let addDays = 0;
            let secondPayDate = moment(this.nextPaydate, "YYYY-MM-DD");
            
            switch(this.payFrequency){
                case "weekly":
                    secondPayDate.add(1, 'weeks');       
                break;
                case "biweekly":
                    secondPayDate.add(2, 'weeks');
                break;
                case "semi-monthly":
                    secondPayDate.add(15, 'days');
                break;
                case "monthly":
                    secondPayDate.add(1, 'months');
                break;
                default:
                    secondPayDate.add(1, 'months');
            }

            while(this.isWeekend(secondPayDate)){
                secondPayDate.subtract(1, 'days');
            }
            this.secondPayDate = secondPayDate.format('YYYY-MM-DD');
            
        },
        getLoanAmountValue(){
            const amounts = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
            const loanAmount = amounts.amounts.find(obj => {
                return obj.label === this.loan_amount;
            });
            this.loan_amount_raw = loanAmount.value;
        }
    },
    watch: {
        zipcode: "getZipCodes",
        nextPaydate: 'calculateSecondPaymentDate',
        payFrequency: 'calculateSecondPaymentDate',
        loan_amount: 'getLoanAmountValue'
    },
    computed: {
        ...mapGetters(["formData", "auth", "loanAmounts"]),
        VUE_APP_SITE_URLNAME(){
            return process.env.VUE_APP_SITE_URLNAME
        },
        formattedHomePhone() {
            return this.formatPhoneNumber(this.auth.userDetails.homePhone)
        },
        formattedWorkPhone() {
            return this.formatPhoneNumber(this.auth.userDetails.workPhone)
        },
        formattedBirthDate(){
            return this.formatBirthDate(this.auth.userDetails.dob);
        },
        birthdate() {
            const date = new Date();
            let d = date.getDate() + 1 < 10 ? `0${date.getDate()+1}` : date.getDate()+1;
            let m = date.getMonth() + 1 < 10 ? `0${date.getMonth()+1}` : date.getMonth()+1;
            return `${m}/${d}/${date.getFullYear()-18}`;
        },
        paymentDates() {
            let now = moment();
            const paymentDates = [];
            let thisDay = now.isoWeekday();
            const daysThisWeek = 5 - thisDay;
            const daysNextWeek = (7 - thisDay) + 5;
            let prefix = "";
            let count = 0;
            
            for(let i=0; i < 30; i++){
                // Make it next day
                now = now.add(1, "days");
                thisDay = thisDay == 7 ? 1 : thisDay + 1;
                switch(true) {
                    case i === 0:
                        prefix = "Tomorrow, ";
                        break;
                    case count <= daysThisWeek: 
                        prefix = "This ";
                        break;
                    case count > daysThisWeek && count <= daysNextWeek:
                        prefix = "Next ";
                        break;
                    default:
                        prefix = '';
                }
                if(thisDay != 6 && thisDay != 7) {
                    paymentDates.push({value: now.format("YYYY-MM-DD"), label: prefix + now.format("dddd, MM-DD-YYYY")});                    
                }
                count++;
            }
            return paymentDates;
        }
    },
    created(){
        
        this.clientKey = this.auth.userDetails.clientKey || '';

        this.email = this.auth.userDetails.email || '';
		this.zipcode = this.auth.userDetails.zip || '';
        this.loan_amount = this.formData.loan_amount || '';

        this.firstName = this.auth.userDetails.firstName || '';
        this.lastName = this.auth.userDetails.lastName || '';
        this.phone = this.formattedHomePhone || '';
        this.dob = this.formattedBirthDate || '';
        this.creditScore = this.auth.userDetails.creditScore || '';
        this.loanPurpose = this.auth.userDetails.loanPurpose || '';        
        this.debtAmount = this.auth.userDetails.debtAmount || '';        

        this.address = this.auth.userDetails.address || '';
        this.city = this.auth.userDetails.city || '';
        this.address_state = this.auth.userDetails.state || '';
        this.monthsAtAddress = this.auth.userDetails.monthsAtAddress || '';
        this.homeOwnership = this.auth.userDetails.homeOwnership || 'rent';
        this.driversLicense = this.auth.userDetails.driversLicense || '';
        this.driversLicenseState = this.auth.userDetails.driversLicenseState || '';

        this.employmentType = this.auth.userDetails.employmentType || 'employed';
        this.employerName = this.auth.userDetails.employerName || '';
        this.monthsEmployed = this.auth.userDetails.monthsEmployed || '';
        this.monthlyIncome = this.auth.userDetails.monthlyIncome || '';
        this.payFrequency = this.auth.userDetails.payFrequency || 'biweekly';
        this.workPhone = this.formattedWorkPhone || '';
        this.workExt = this.auth.userDetails.workExt || '';
        this.payType = this.auth.userDetails.payType || 'direct_deposit';

        this.bankAccountType = this.auth.userDetails.bankAccountType || 'checking';
        this.bankRoutingNumber = this.auth.userDetails.bankRoutingNumber || '';
        this.bankAccountNumber = this.auth.userDetails.bankAccountNumber || '';
        this.bankName = this.auth.userDetails.bankName || '';
        this.monthsAtBank = this.auth.userDetails.monthsAtBank || '';
        this.ssn = this.auth.userDetails.ssn || '';

        this.sid = this.auth.userDetails.sid || '';
        this.bid = this.auth.userDetails.bid || '';
        this.did = this.auth.userDetails.did || '';
    },
    mounted(){
        this.registerPoint('shortFormStart');
    }
}
</script>

